// extracted by mini-css-extract-plugin
module.exports = {"group":"Select_group__2M9wq","label":"Select_label__2wsd8 form_label__FEn27 typography_heading3__2drgN"};